import {
  Building2,
  ChevronRight,
  FileSignature,
  ScanBarcode,
  Settings,
} from "lucide-react";
import { useTranslate } from "ra-core";
import type { ComponentType, SVGProps } from "react";
import { Link } from "react-router";

import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet";

interface MoreSection {
  href: string;
  Icon: ComponentType<SVGProps<SVGSVGElement>>;
  label: string;
}

/** Paths reached from the "More" panel: the button stays lit on them */
export const MORE_PATHS = [
  "/companies",
  "/agreements",
  "/test_rackets",
  "/settings",
];

/**
 * Sections that do not fit in the bottom bar (task 1.12, D-044): two taps
 * from anywhere, the button and then the section.
 */
export const MoreSheet = ({
  open,
  onOpenChange,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}) => {
  const translate = useTranslate();
  const sections: MoreSection[] = [
    {
      href: "/companies",
      Icon: Building2,
      label: translate("resources.companies.name", { smart_count: 2 }),
    },
    {
      href: "/agreements",
      Icon: FileSignature,
      label: translate("resources.agreements.name", { smart_count: 2 }),
    },
    {
      href: "/test_rackets",
      Icon: ScanBarcode,
      label: translate("tenax.rackets.title"),
    },
    {
      href: "/settings",
      Icon: Settings,
      label: translate("crm.settings.title"),
    },
  ];
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="bottom"
        className="pb-[max(1rem,env(safe-area-inset-bottom))]"
        aria-describedby={undefined}
      >
        <SheetHeader>
          <SheetTitle>{translate("tenax.mobile.more_title")}</SheetTitle>
        </SheetHeader>
        <nav className="flex flex-col px-2">
          {sections.map(({ href, Icon, label }) => (
            <Link
              key={href}
              to={href}
              onClick={() => onOpenChange(false)}
              className="flex min-h-12 items-center gap-4 rounded-md px-3 text-base no-underline hover:bg-muted"
            >
              <Icon className="size-5 text-muted-foreground" />
              <span className="flex-1">{label}</span>
              <ChevronRight className="size-4 text-muted-foreground" />
            </Link>
          ))}
        </nav>
      </SheetContent>
    </Sheet>
  );
};
